import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path , Polygon} from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function UpArrowIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 255 255"
    >
      <g>
        <g id="arrow-drop-up">
          <Polygon points="0,191.25 127.5,63.75 255,191.25   " fill={color}/>
        </g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
    </Svg>
  );
}

UpArrowIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

UpArrowIcon.defaultProps = {
  height: 21,
  width: 32,
};

export default pure(UpArrowIcon);
